module.exports = __webpack_public_path__ + "static/img/jxhwEn.6ea2b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jxhwEn.png
// module id = aSKc
// module chunks = 23